import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Row,
  Button,
  Spinner,
  Carousel,
  CardHeader,
  Modal,
} from "react-bootstrap";

import { BASE_URL, HEADERS, roleData } from "../../utils/constant";
import { toast } from "react-toastify";
import axios from "axios";
import {
  FaSearch,
  FaUser,
  FaCircle,
  FaArrowRight,
  FaTicketAlt,
  FaThumbsUp,
  FaPhone,
  FaCalendarCheck,
  FaPhoneSlash,
  FaLock,
  FaUserClock,
  FaChartPie,
  FaUserSlash,
} from "react-icons/fa";

import AttendancePieChart from "../../components/Piechart";
import TicketPieChart from "../../components/Piechart/Piechart1";
import GenerateTicketsModal from "../../components/Modals/GenerateTicketsModal";
import AmcPieChart from "../../components/Piechart/amcchart";
import TechnicianDashboard from "../TechnicianDashboard";
import {
  FaCheckCircle,
  FaClock,
  FaUserCheck,
  FaUserTimes,
  FaUsers,
  FaTimesCircle,
  FaPauseCircle,
} from "react-icons/fa";
import { useCommonContext } from "../../utils/context";
import CustomerTicket from "../../components/Modals/CustometTicketModel";
import { Link, useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
// import LocationFetcher from "../../utils/LocationFetcher";

const MainDashboard = () => {
  const navigate = useNavigate();
  const [ticketAction, setTicketAction] = useState("");
  const currentRole = localStorage.getItem("role");
  const { user } = useCommonContext();
  const [coords, setCoords] = useState(null);
  const { subscription, fetchSubscription, isSubscriptionDisabled } =
    useCommonContext();

  const [todayCalls, setTodayCalls] = useState([]);
  const [missedCalls, setMissedCalls] = useState([]);
  const [filter, setFilter] = useState("all");
  const userPermissions = localStorage.getItem("user_permissions");
  const [isLeaveModalVisible, setIsLeaveModalVisible] = useState(false);
  const [TodaycurrentPage, setTodayCurrentPage] = useState(1);
  const [todayTotalPages, setTodayTotalPages] = useState(1);

  const [itemsTodayPerPage, setTodayItemsPerPage] = useState(10);
  const [itemTodayOffset, setTodayItemOffset] = useState(0);
  const endTodayOffset = itemTodayOffset + itemsTodayPerPage;

  const [MissedcurrentPage, setMissedCurrentPage] = useState(1);
  const [missedTotalPages, setMissedTotalPages] = useState(0);
  const [itemsMissedPerPage, setMissedItemsPerPage] = useState(10);
  const [itemMissedOffset, setMissedItemOffset] = useState(0);
  const endMissedOffset = itemMissedOffset + itemsMissedPerPage;

  const currentTodayCalls = todayCalls.slice(itemTodayOffset, endTodayOffset);
  const currentMissedCalls = missedCalls.slice(
    itemMissedOffset,
    endMissedOffset,
  );

  const TicketComponent =
    currentRole === "customer" || currentRole === "subcustomer"
      ? CustomerTicket
      : GenerateTicketsModal;

  const handleTodayPageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setTodayCurrentPage(newPage);
  };

  const STATUS_COLORS = {
    Accepted: "#28a745",
    "Not-Assigned": "#343a40",
    Rejected: "#dc3545",
    Ongoing: "#ffc107",
    Completed: "#0088FE",
    "On-hold": "#fd7e14",
    Autoclose: "#800080",
    Inactive: "#6c757d",
    Default: "#343a40",
  };

  const [showTicketModal, setShowTicketModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rating, setRating] = useState([]);
  const [timeFilter, setTimeFilter] = useState("month");

  const [todayTickets, setTodayTickets] = useState([]);

  const [averageRating, setAverageRating] = useState(0);
  const [ratingCounts, setRatingCounts] = useState({});

  const { attendanceData } = useCommonContext();
  const [searchTicketText, setSearchTicketText] = useState("");
  const { ticketStats, isLoading } = useCommonContext();

  const { amcData, fetchAmcData } = useCommonContext();

  const [isPunchInModalVisible, setIsPunchInModalVisible] = useState(false);
  const [isDashboardDisabled, setIsDashboardDisabled] = useState(true);
  const punchInRoles = ["sales", "technician", "superuser", "agent"];

  const todayDate = new Date().toISOString().split("T")[0];
  const [attendanceType, setAttendanceType] = useState(
    localStorage.getItem("attendence_type") || "",
  );

  const handleLeaveModalShow = () => {
    setIsLeaveModalVisible(true);
  };

  useEffect(() => {
    const storedType = localStorage.getItem("attendence_type");
    if (storedType && storedType !== attendanceType)
      setAttendanceType(storedType);
  }, []);

  useEffect(() => {
    if (!user) return;

    const hasRolePermission = punchInRoles.includes(currentRole);
    const notMachine = attendanceType !== "machine";
    const punchin = user?.today_attendance?.punch_in;

    if (hasRolePermission && notMachine && !punchin) {
      setIsPunchInModalVisible(true);
      setIsDashboardDisabled(true);
    } else {
      setIsPunchInModalVisible(false);
      setIsDashboardDisabled(false);
    }
  }, [attendanceType, user, currentRole]);

  const getPunchInModal = () => {
    return (
      punchInRoles.includes(currentRole) && (
        <Modal
          show={isPunchInModalVisible}
          centered
          backdrop="static"
          dialogClassName="small-punch-in-modal"
        >
          <Modal.Body className="text-center p-4">
            <h5 className="mb-3" style={{ fontWeight: 600, color: "#343a40" }}>
              Hello! 👋
            </h5>
            <p className="text-muted" style={{ fontSize: "0.95rem" }}>
              Please punch in via the mobile app to access your dashboard.
            </p>

            <p className="mt-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Not working today?{" "}
              <span
                onClick={() => navigate("/dashboard/my-leave")}
                style={{
                  color: "#007bff",
                  cursor: "pointer",
                  fontWeight: 500,
                  textDecoration: "underline",
                }}
              >
                Apply for Leave
              </span>
            </p>
          </Modal.Body>
        </Modal>
      )
    );
  };

  const handleClick = () => {
    navigate("/dashboard/track-all");
  };

  useEffect(() => {
    fetchSubscription();
    fetchTodayTickets();
  }, []);

  useEffect(() => {
    fetchLeadData("today", TodaycurrentPage);
  }, [TodaycurrentPage]);

  useEffect(() => {
    fetchLeadData("yesterday", MissedcurrentPage);
  }, [MissedcurrentPage]);

  const fetchLeadData = async (interactionType, page = 1) => {
    setLoading(true);
    try {
      const queryParams = {
        next_interaction: interactionType,
        page: page,
      };

      const response = await axios.get(`${BASE_URL}/api/leads/`, {
        headers: HEADERS,
        params: queryParams,
      });

      if (response && response.data) {
        if (interactionType === "today") {
          setTodayCalls(response.data.results || []);
          setTodayTotalPages(Math.ceil(response.data.total_pages));
          setTodayCurrentPage(page);
        } else if (interactionType === "yesterday") {
          setMissedCalls(response.data.results || []);
          setMissedTotalPages(Math.ceil(response.data.total_pages));
          setMissedCurrentPage(page);
        }
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const filteredCalls =
    filter === "today"
      ? todayCalls
      : filter === "missed"
        ? missedCalls
        : [...todayCalls, ...missedCalls];

  const handleLogout = () => {
    localStorage.clear();

    navigate("/");
  };

  const statuses = [
    "Completed",
    "Autoclose",
    "Accepted",
    "Not-Assigned",
    "Ongoing",
    "On-Hold",
    "Inactive",
    "Rejected",
  ];

  const fetchTodayTickets = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL}/api/tickets/todays_tickets/`,
        {
          headers: HEADERS,
        },
      );
      if (response && response.data) {
        setTodayTickets(response.data?.todays_tickets || []);
      }
    } catch (error) {
      console.error("Failed to fetch subscription data");
    } finally {
      setLoading(false);
    }
  };

  const calculateTrialDaysLeft = () => {
    if (!subscription?.trial_end_date) return 0;

    const trialEndDate = new Date(subscription.trial_end_date);
    const currentDate = new Date();

    const timeDifference = trialEndDate.getTime() - currentDate.getTime();
    const daysLeft = Math.ceil(timeDifference / (1000 * 3600 * 24));

    return daysLeft > 0 ? daysLeft : 0;
  };

  const daysLeft = calculateTrialDaysLeft();

  const handleBuyNow = () => {
    navigate("/dashboard/subscription");
  };

  const getIconByStatus = (status) => {
    switch (status) {
      case "Completed":
        return <FaCheckCircle size={30} />;
      case "Ongoing":
        return <FaClock size={30} />;
      case "On-Hold":
        return <FaPauseCircle size={30} />;
      case "Inactive":
        return <FaUserTimes size={30} />;
      case "Rejected":
        return <FaTimesCircle size={30} />;
      case "Total Tickets":
        return <FaTicketAlt size={30} />;
      case "Accepted":
        return <FaThumbsUp size={30} />;
      case "Autoclose":
        return <FaLock size={30} />;
      case "Not-Assigned":
        return <FaUserSlash size={30} />;

      default:
        return <FaUsers size={30} />;
    }
  };

  const hasDashboardContent =
    userPermissions.includes("ticket_view_ticket") ||
    userPermissions.includes("attendance_view_all_attendance") ||
    userPermissions.includes("amc_view_amc") ||
    userPermissions.includes("lead_view_lead");

  const EmptyDashboard = () => (
    <div
      className="d-flex flex-column justify-content-center align-items-center text-center"
      style={{ minHeight: "60vh" }}
    >
      <FaChartPie size={60} className="text-muted mb-3" />
      <h4 className="fw-bold text-dark">No Dashboard Data Available</h4>
      <p className="text-muted mb-3" style={{ maxWidth: "420px" }}>
        You don’t have access to any dashboard modules yet, or there is no data
        available at the moment.
      </p>
      <p className="text-muted">
        Please contact your administrator or check back later.
      </p>
    </div>
  );

  const getDashboardContent = () => {
    return (
      <>
        {getPunchInModal()}

        {isSubscriptionDisabled && (
          <Modal
            show={isSubscriptionDisabled}
            centered
            backdrop="static"
            className="custom-modal"
          >
            <Modal.Header className="bg-white border-bottom">
              <Modal.Title
                style={{
                  fontWeight: "700",
                  fontSize: "1.5rem",
                  color: "#343a40",
                }}
              >
                Trial Period Ended
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ fontSize: "1rem", color: "#495057" }}>
              <p>
                Your trial has expired. Please buy a subscription to continue
                enjoying our services.
              </p>
            </Modal.Body>
            <Modal.Footer className="bg-white border-top">
              <Button
                variant="primary"
                onClick={handleBuyNow}
                style={{ padding: "10px 20px" }}
              >
                Buy Now
              </Button>
              <Button
                variant="danger"
                onClick={handleLogout}
                style={{ padding: "10px 20px" }}
              >
                Log Out
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        <div
          style={{
            pointerEvents:
              isDashboardDisabled || isSubscriptionDisabled ? "none" : "auto",
            opacity: isDashboardDisabled || isSubscriptionDisabled ? 0.5 : 1,
          }}
        >
          {currentRole === roleData.superadmin ? (
            <TechnicianDashboard />
          ) : (
            <>
              <Card
                className="shadow-lg border-0 p-3"
                style={{ minHeight: "80vh" }}
              >
                {!hasDashboardContent ? (
                  <EmptyDashboard />
                ) : (
                  <>
                    <Row className="g-3">
                      {userPermissions.includes("ticket_view_ticket") && (
                        <Col
                          md={
                            userPermissions.includes(
                              "attendance_view_all_attendance",
                            )
                              ? 6
                              : 12
                          }
                        >
                          <div className="p-3 bg-white shadow-sm rounded h-100">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="mb-0">Ticket Distribution</h5>
                              {userPermissions.includes(
                                "ticket_add_ticket",
                              ) && (
                                <Button
                                  variant="primary"
                                  onClick={() => setShowTicketModal(true)}
                                >
                                  Create Ticket
                                </Button>
                              )}
                            </div>
                            <Row className="g-3">
                              {statuses.map((status, index) => (
                                <Col xs={12} sm={6} md={4} key={index}>
                                  <DashboardWidget
                                    title={status}
                                    value={
                                      isLoading
                                        ? "Loading..."
                                        : ticketStats[status.toLowerCase()] || 0
                                    }
                                    icon={getIconByStatus(status)}
                                    onClick={() =>
                                      navigate(
                                        `/dashboard/tickets?status=${status}`,
                                      )
                                    }
                                  />
                                </Col>
                              ))}

                              <Col xs={12} sm={6} md={4}>
                                <DashboardWidget
                                  title="Total Tickets"
                                  value={
                                    isLoading
                                      ? "Loading..."
                                      : ticketStats.total || 0
                                  }
                                  icon={<FaUsers size={30} />}
                                  onClick={() => navigate("/dashboard/tickets")}
                                />
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      )}

                      {userPermissions.includes(
                        "attendance_view_all_attendance",
                      ) && (
                        <Col
                          md={
                            userPermissions.includes("ticket_view_ticket")
                              ? 6
                              : 12
                          }
                        >
                          <div className="p-3 bg-white shadow-sm rounded h-100">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                              <h5 className="mb-0">Today’s Attendance</h5>
                              <Button variant="primary" onClick={handleClick}>
                                Track All
                              </Button>
                            </div>
                            <Row className="g-3">
                              {[
                                {
                                  label: "Present",
                                  key: "total_present",
                                  color: "#00C49F",
                                  icon: <FaUserCheck size={30} />,
                                },
                                {
                                  label: "Absent",
                                  key: "total_absent",
                                  color: "#FF8042",
                                  icon: <FaUserTimes size={30} />,
                                },
                                {
                                  label: "Idle",
                                  key: "total_idle",
                                  color: "#FFBB28",
                                  icon: <FaPauseCircle size={30} />,
                                },
                                {
                                  label: "On-Leave",
                                  key: "total_onleave",
                                  color: "#8884d8",
                                  icon: <FaUserClock size={30} />,
                                },
                                {
                                  label: "Total",
                                  key: "total_users",
                                  color: "#0088FE",
                                  icon: <FaUsers size={30} />,
                                },
                              ].map((item, index) => (
                                <Col xs={12} sm={6} md={4} key={index}>
                                  <DashboardWidget
                                    title={item.label}
                                    value={attendanceData?.[item.key] ?? 0}
                                    color={item.color}
                                    icon={item.icon}
                                  />
                                </Col>
                              ))}
                            </Row>
                          </div>
                        </Col>
                      )}
                    </Row>

                    <Row className="mt-4 g-3">
                      {userPermissions.includes("ticket_view_ticket") && (
                        <Col
                          md={
                            userPermissions.includes(
                              "attendance_view_all_attendance",
                            )
                              ? 6
                              : 12
                          }
                        >
                          <div className="p-3 bg-white shadow-sm rounded">
                            <TicketPieChart />
                          </div>
                        </Col>
                      )}
                      {userPermissions.includes(
                        "attendance_view_all_attendance",
                      ) && (
                        <Col
                          md={
                            userPermissions.includes("ticket_view_ticket")
                              ? 6
                              : 12
                          }
                        >
                          <div className="p-3 bg-white shadow-sm rounded">
                            <AttendancePieChart data={attendanceData} />
                          </div>
                        </Col>
                      )}
                    </Row>

                    <Row className="g-3">
                      {(() => {
                        const activeSections = [
                          userPermissions.includes("amc_view_amc"),
                          userPermissions.includes("ticket_view_ticket"),
                          userPermissions.includes("lead_view_lead"),
                        ].filter(Boolean).length;

                        const colSize =
                          activeSections > 0
                            ? Math.floor(12 / activeSections)
                            : 4;

                        return (
                          <>
                            {userPermissions.includes("amc_view_amc") && (
                              <Col md={colSize}>
                                <div className="p-3 bg-white shadow-sm rounded h-100 d-flex flex-column">
                                  <h5 className="mb-3">AMC Status</h5>
                                  <div className="flex-grow-1 d-flex justify-content-center align-items-center">
                                    <AmcPieChart />
                                  </div>
                                </div>
                              </Col>
                            )}
                            {userPermissions.includes("ticket_view_ticket") && (
                              <Col md={colSize}>
                                <div className="p-3 bg-white shadow-sm rounded h-100">
                                  <h5 className="mb-3">Today's Tickets</h5>
                                  <div
                                    className="overflow-auto"
                                    style={{
                                      maxHeight: "230px",
                                      minHeight: "150px",
                                    }}
                                  >
                                    {todayTickets.length > 0 ? (
                                      todayTickets.map((ticket) => (
                                        <Card
                                          key={ticket.id}
                                          className="mb-3 border-0 shadow-sm"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            navigate(
                                              `/dashboard/tickets?id=${ticket.id}`,
                                            )
                                          }
                                        >
                                          <Card.Body className="p-2">
                                            <div className="mb-2">
                                              <div className="d-flex justify-content-between align-items-center mb-2">
                                                <div className="d-flex align-items-center">
                                                  <FaTicketAlt
                                                    size={18}
                                                    className="me-2 text-primary"
                                                  />
                                                  <h6 className="mb-0 fw-bold text-dark">
                                                    {ticket.taskName}
                                                  </h6>
                                                </div>

                                                <div className="d-flex align-items-center">
                                                  {ticket.rate && (
                                                    <span
                                                      className="fw-bold text-danger me-3"
                                                      style={{
                                                        fontSize: "0.95rem",
                                                      }}
                                                    >
                                                      ₹{ticket.rate}
                                                    </span>
                                                  )}
                                                  <span
                                                    className="fw-bold px-2 py-1 rounded-pill text-white"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        STATUS_COLORS[
                                                          ticket.status
                                                        ] ||
                                                        STATUS_COLORS.Default,
                                                    }}
                                                  >
                                                    {ticket.status}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="d-flex justify-content-between align-items-center bg-light  rounded mb-1">
                                                <div className="d-flex align-items-center">
                                                  <FaUser
                                                    size={16}
                                                    className="me-2 text-secondary"
                                                  />
                                                  <div>
                                                    <span
                                                      className="fw-semibold text-dark"
                                                      style={{
                                                        fontSize: "0.85rem",
                                                      }}
                                                    >
                                                      {
                                                        ticket.customerDetails
                                                          ?.customer_name
                                                      }
                                                    </span>
                                                    <p
                                                      className="mb-0 text-muted"
                                                      style={{
                                                        fontSize: "0.75rem",
                                                      }}
                                                    >
                                                      Customer
                                                    </p>
                                                  </div>
                                                </div>

                                                <div className="d-flex align-items-center">
                                                  <FaPhone
                                                    size={14}
                                                    className="me-2 text-secondary"
                                                  />
                                                  <span
                                                    className="fw-semibold text-dark"
                                                    style={{
                                                      fontSize: "0.85rem",
                                                    }}
                                                  >
                                                    {ticket.phone_number}
                                                  </span>
                                                </div>
                                              </div>
                                              <div className="d-flex align-items-center">
                                                <span
                                                  className="fw-semibold text-dark"
                                                  style={{
                                                    fontSize: "0.85rem",
                                                  }}
                                                >
                                                  Assigned To:{" "}
                                                  {ticket.assignTo?.first_name}{" "}
                                                  {ticket.assignTo?.last_name}
                                                </span>
                                              </div>
                                            </div>
                                          </Card.Body>
                                        </Card>
                                      ))
                                    ) : (
                                      <p className="text-muted text-center">
                                        No tickets available
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            )}
                            {userPermissions.includes("lead_view_lead") && (
                              <Col md={colSize}>
                                <div className="p-3 bg-white shadow-sm rounded h-100 d-flex flex-column">
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="mb-0">Call Statistics</h5>
                                  </div>
                                  <div className="p-3">
                                    <Row>
                                      <Col xs={6}>
                                        <div
                                          className={`p-2 rounded text-center ${
                                            filter === "today"
                                              ? "bg-primary text-white"
                                              : "bg-white"
                                          }`}
                                          style={{ cursor: "pointer" }}
                                          onClick={() => setFilter("today")}
                                        >
                                          <FaPhone size={20} className="me-1" />
                                          <div className="fw-bold">
                                            Today's Calls
                                          </div>
                                        </div>
                                      </Col>
                                      <Col xs={6}>
                                        <div
                                          className={`p-2 rounded text-center ${
                                            filter === "missed"
                                              ? "bg-danger text-white"
                                              : "bg-white"
                                          }`}
                                          style={{ cursor: "pointer" }}
                                          onClick={() => setFilter("missed")}
                                        >
                                          <FaPhoneSlash
                                            size={20}
                                            className="me-1"
                                          />
                                          <div className="fw-bold">
                                            Missed Calls
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  </div>
                                  <div
                                    className="flex-grow-1 overflow-auto p-2"
                                    style={{ maxHeight: "205px" }}
                                  >
                                    {filteredCalls.length > 0 ? (
                                      filteredCalls.map((call) => (
                                        <div
                                          key={call.id}
                                          className="mb-1 p-2 rounded shadow-sm bg-white border d-flex flex-column"
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            navigate(
                                              `/dashboard/lead-list?lead_id=${call.id}`,
                                            )
                                          }
                                        >
                                          <div className="d-flex justify-content-between align-items-center">
                                            <span
                                              className="font-weight-bold text-dark"
                                              style={{ fontSize: "0.8rem" }}
                                            >
                                              {call.companyName || (
                                                <span className="text-muted">
                                                  Unknown Company
                                                </span>
                                              )}
                                            </span>
                                            {call.mobile && (
                                              <span
                                                className="text-danger font-weight-bold d-flex align-items-center"
                                                style={{ fontSize: "0.8rem" }}
                                              >
                                                <FaPhone
                                                  style={{
                                                    fontSize: "0.6rem",
                                                    marginRight: "0.2rem",
                                                  }}
                                                />
                                                {call.mobile}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div
                                        className="d-flex justify-content-center align-items-center"
                                        style={{ height: "100%" }}
                                      >
                                        <p className="text-muted fw-bold">
                                          No calls found
                                        </p>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Col>
                            )}
                          </>
                        );
                      })()}
                    </Row>
                  </>
                )}
              </Card>
            </>
          )}
        </div>
      </>
    );
  };

  return (
    <>
      {getDashboardContent()}
      {showTicketModal && (
        <TicketComponent
          show={showTicketModal}
          handleClose={() => setShowTicketModal(false)}
          setTicketAction={() => setTicketAction("add")}
        />
      )}
    </>
  );
};

export default MainDashboard;

const DashboardWidget = ({ title, value, icon, onClick }) => (
  <Card
    className="h-100 rounded-lg shadow-sm d-flex w-100"
    style={{
      backgroundColor: "#fffbe6",
      border: "1px solid #f7e6a1",
      cursor: "pointer",
      transition: "transform 0.2s ease-in-out",
    }}
    onClick={onClick}
  >
    <Card.Body className="d-flex align-items-center p-2 gap-2 flex-wrap">
      <div
        className="rounded-circle d-flex justify-content-center align-items-center flex-shrink-0"
        style={{
          width: "40px",
          height: "40px",
          backgroundColor: "#ffedc2",
          color: "#6c757d",
          fontSize: "1.3rem",
        }}
      >
        {icon}
      </div>
      <div
        className="text-start text-break"
        style={{
          minWidth: 0,
          flex: 1,
        }}
      >
        <h6
          className="card-title mb-1 text-truncate"
          style={{
            fontWeight: "500",
            fontSize: "0.9rem",
            color: "#343a40",
            maxWidth: "100%",
          }}
          title={title}
        >
          {title}
        </h6>
        <p
          className="card-text mb-0"
          style={{
            fontSize: "1.3rem",
            fontWeight: "600",
            color: "#343a40",
            wordBreak: "break-word",
          }}
        >
          {value}
        </p>
      </div>
    </Card.Body>
  </Card>
);
